
export class PermissionConstants{

    public static READ = "Read";
    public static EDIT = "Edit";
    public static DOWNLOAD = "Download";
    public static MANAGE_CERTIFICATES = "ManageCertificates"
}